import React from 'react';
import { Box, Skeleton } from '@mui/material';

const GalleryViewerSkeleton = () => {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "4px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        border: "1px solid #e0e0e0",
        mb: 4,
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height={{ xs: 250, sm: 350, md: 450, lg: 500 }}
        sx={{ bgcolor: "#f5f5f5", transform: "none" }}
      />
    </Box>
  );
};

export default GalleryViewerSkeleton;